export const IMAGE_THUMBNAILS_DIR = '300xauto'
export const MAX_BUCKET_GROUP_NAME_LENGTH = 30
